import Mapview from "components/Mapview/Mapview";

export default function ViewMgtDeviceStatusMap({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
  
  const latLng = device?.LastValidLocationUpdateLog?.location?.latLng;
  const lockResultLog = device?.LastSuccessfulLockResultLog ?? device?.LockResultLog;

  if (!latLng) {
    return <div>...</div>;
  }

  return (
    <Mapview
      nopopup
      minHeight={'362px'}
      //TODO:tamperAlert={tamperActive}
      isLocked={lockResultLog?.requestLock}
      vehicle={{ lat: latLng.latitudeDeg, lng: latLng.longitudeDeg }} />
  );
}
